import { HubDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useConfirmationAction } from '../../../hooks/confirmation-action.hook';
import { useMutationUpdateHubStatus } from '../../hubs.queries';
import {
  ConfirmationModal,
  ConfirmationNote
} from '../../../../ui/components/pure/modal-content/confirmation-modal.component';

export function EnableHubModal({
  hub,
  projectID,
  onAbort,
  onSuccess
}: {
  hub: HubDto;
  projectID: string;
  onAbort(): void;
  onSuccess(): void;
}) {
  const { onConfirm, state } = useConfirmationAction({
    mutationHook: useMutationUpdateHubStatus,
    mutationArgs: (note?: ConfirmationNote) => ({
      projectID: projectID,
      hubID: hub.id,
      enable: true,
      note: {
        content: note?.content ?? '',
        private: note?.visibility === 'private'
      }
    }),
    onSuccess,
    modalCloseDelay: 300
  });

  return (
    <ConfirmationModal
      title="Enable Hub"
      content={[]}
      noteRequired
      noteMessage="Why are you enabling this hub?"
      onConfirm={onConfirm}
      onCancel={onAbort}
      actionButton={{
        label: 'Enable',
        color: 'primary'
      }}
      cancelButton={{
        label: 'Cancel'
      }}
      {...state}
    />
  );
}
